"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notice = void 0;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./Notice.css"));
var _ContentLayout = require("../ContentLayout");
var _uiKit = require("@cian/ui-kit");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Notice = _ref => {
  let {
    title,
    text
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['notice-wrapper']
  }, /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement("div", {
    className: styles['notice-content']
  }, /*#__PURE__*/React.createElement(_uiKit.IconFunctionalWarningSign24, {
    color: "icon-warning-default"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['notice']
  }, title && /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, title), /*#__PURE__*/React.createElement(_uiKit.ArticleParagraph2, null, text)))));
};
exports.Notice = Notice;